<template>
  <v-row justify="center">
    <v-col md="8" lg="6" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="createForm" v-model="valid">
          <v-card-title>
            <h2>{{ title || $t("admin.team.create.title") }}</h2>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="data.name"
              :label="$t('admin.team.edit.name')"
              :rules="[$v.required(), $v.maxLength(255)]"
              required
            ></v-text-field>
            <v-text-field
              v-model="data.slug"
              :rules="[$v.maxLength(255)]"
              :label="$t('admin.team.edit.slug')"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="!valid">
              {{ $t("admin.team.edit.confirm") }}
            </v-btn>
            <v-btn color="secondary" text @click="cancel()">
              {{ $t("admin.team.edit.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import slugify from "slugify";

export default {
  props: {},
  data() {
    return {
      data: {},
      title: "",
      valid: false,
      messages: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (this.$route.params.id) {
        this.data = await this.$axios.get(`/event/teams/${this.$route.params.id}`);
        this.title = this.data.name;
      }
    },
    async save() {
      if (!this.$data.valid) return;
      this.data.id_event = this.$route.params.eventId;
      if (this.$route.params.id) {
        await this.$axios.put(`/admin/teams/${this.$route.params.id}`, this.data);
      } else {
        await this.$axios.post(`/admin/teams/`, this.data);
      }
      this.$store.commit("SUCCESS", this.$t("admin.team.edit.msgSaved"));
      this.$router.push({ name: "teams" });
    },

    cancel() {
      this.$router.push({ name: "teams" });
    },
  },
  watch: {
    "data.name": {
      handler() {
        this.data.slug = slugify(this.data.name, { remove: /[*+~.()'"!:@&]/g, lower: true });
      },
      deep: true,
    },
  },
};
</script>
